var base = require('./base');
var detail = require('base/product/detail');
var minicart = require('../components/miniCart');
var gtm = require('googletagmanager/tagManager');
var cartHelpers = require('../utilities/cartHelpers');
const { throttle } = require('../utilities');
const Snackbar = require('../components/snackbar');

var TRY_IT_IFRAME_HEIGHT_BUFFER = 8;
var TRY_IT_IFRAME_ASPECT_RATIO_WIDTH = 16;
var TRY_IT_IFRAME_ASPECT_RATIO_HEIGHT = 11;
var TRY_IT_MOBILE_BREAKPOINT = 768;
var TRY_IT_MOBILE_MAX_DIMENSION = 1024;
var TRY_IT_MIRROR_ME_NON_MOBILE_WIDTH_SAFETY_FACTOR = 0.95;
var TRY_IT_DIALOG_VERTICAL_MARGIN = 16;

detail.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        var $addToCartBtn = $('button.add-to-cart .js-atc-main', response.$productContainer);
        var isDiscontinued = response.product.custom && response.product.custom.isDiscontinuedProduct;
        // update local add to cart (for sets)
        if (response.resources && response.resources.addtoCart && response.resources.outOfStock ) {
            if (!response.product.readyToOrder || !response.product.available) {
                $addToCartBtn.html(response.resources.outOfStock);
            } else {
                $addToCartBtn.html(`<svg class="icon--sm mr-2" aria-hidden="true" aria-label="Add to Bag Icon"><use xlink:href="${window.STATIC_URL}/images/compiled/sprites.svg#mk-icons-plus-white"></use></svg>` + response.resources.addtoCart);
            }
        }
        $('button.add-to-cart', response.$productContainer).attr(
            'disabled',
            (!response.product.readyToOrder || !response.product.available || isDiscontinued)
        );

        var enable = $('.product-availability').toArray().every(function (item) {
            return $(item).data('available') && $(item).data('ready-to-order');
        });
        detail.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
};

detail.productSubscriptionOptions = function () {
    $('body').on('change', '.js-product-subscription-type', function () {
        var $container = $(this).closest('.js-product-subscription');
        var isSubscription = $container.find('.js-product-subscription-type:checked').val() === 'subscription';
        $container.find('.js-product-subscription-frequency-group').toggleClass('d-none', !isSubscription);
    });

    $(document).on('updateAddToCartFormData', function (e, form) {
        var $container = $(e.target).closest('.product-detail').find('.js-product-subscription').first();
        if (!$container.length) {
            return;
        }
        if ($container.find('.js-product-subscription-type:checked').val() === 'subscription') {
            form.isSubscription = true; // eslint-disable-line no-param-reassign
            form.subscriptionFrequencyDays = $container.find('.js-product-subscription-frequency').val(); // eslint-disable-line no-param-reassign
        }
    });
};

detail.handleSlickSlotAddToCart = function () {
    $('body').on('click', '.add-to-cart-button-slick-slot', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var  $addToCartButton = $(this);

        // Prevent multiple clicks
        if ($addToCartButton.prop('disabled') || $addToCartButton.attr('aria-disabled') === 'true') {
            e.stopImmediatePropagation();
            return;
        }

        // Validate URL
        var url = $addToCartButton.data('url');
        if (!url) {
            console.error('Add to cart URL not found');
            return;
        }

        // Get product ID
        var pid = $addToCartButton.data('pid');
        var $product = $addToCartButton.closest('.product');
        var $selectedSwatch = $product.find('.swatch-link.selected.swatch-active .swatch-value');

        if ($selectedSwatch.length && $selectedSwatch.data('variant-id')) {
            pid = $selectedSwatch.data('variant-id');
        }

        // Get quantity
        var quantity = parseInt($selectedSwatch.data('quantity'), 10) || 1;
        var maxQty = parseInt($selectedSwatch.data('max-quantity'), 10) || 999;
        quantity = Math.min(quantity, maxQty);

        // Disable button and show spinner
        $addToCartButton.prop('disabled', true);
        $.spinner().start();

        // AJAX call
        $.ajax({
            url: url,
            type: 'post',
            data: {
                pid: pid,
                quantity: quantity
            },
            success: function (data) {
                if (data.cartItemsHTML) {
                    $('.cart-product-items').empty().html(data.cartItemsHTML);
                }

                if (data.productData && data.productData.quantity !== undefined) {
                    gtm.addToCart(data.productData, data.productData.quantity);
                }

                if (data.quantityTotal && data.quantityTotal === 1) {
                    gtm.openCart();
                }

                $('.minicart').trigger('count:update', data);
                minicart.miniCartShow();

                var trayOpened = false;
                $('body').on('trayModalOpened', function (eTMO, traydata) {
                    if (!trayOpened && data.maxQty && data.maxQty.error && traydata.customClassName.includes('mini-cart-tray')) {
                        $('.minicart-maxqty-error').addClass('alert alert-danger p-4');
                        var errorHtml = '<strong class="title mb-1 font-weight-xbold small d-block">' + data.maxQty.message + '</strong>'
                            + '<p class="m-0 small mk-text-color-black">' + data.maxQty.msg + '</p>';
                        $('.minicart-maxqty-error').append(errorHtml);
                        trayOpened = true;
                    }
                });

                cartHelpers.updateCartTotals(data); // ✅ Use shared utility

                $.spinner().stop();
                $addToCartButton.prop('disabled', false);
            },
            error: function (xhr) {
                $.spinner().stop();
                $addToCartButton.prop('disabled', false);

                var errorMessage = 'Unable to add item to cart. Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.errorMessage) {
                    errorMessage = xhr.responseJSON.errorMessage;
                }

                Snackbar.show({
                    message: errorMessage,
                    actionText: 'Dismiss',
                    actionHandler: function () {}
                });
            }
        });
    });
};

const toggleStickyAtb = ($stickyAtb, windowScrollTop, actualAtbOffsetTop) => {
    // Show sticky atb when actual atb is out of window due to scroll. Hide sticky atb when actual atb is in window due to scroll.
    if (windowScrollTop > actualAtbOffsetTop) {
        if ($stickyAtb.hasClass('hidden')) {
            $stickyAtb.removeClass('hidden');
        }
        $stickyAtb.addClass('visible');
    } else if ($stickyAtb.hasClass('visible')) {
        $stickyAtb.removeClass('visible');
        $stickyAtb.addClass('hidden');
        $stickyAtb.one(
            'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
            function () {
                $stickyAtb.removeClass('hidden');
            }
        );
    }
};

// jQuery IIFE to listen to scroll event
(function ($) {
    const $window = $(window);
    const $actualAtb = $('.pricing-actions .add-to-cart');
    const $stickyAtb = $('.sticky-atb');

    $window.on('scroll', throttle(function () {
        const windowScrollTop = $window.scrollTop();
        const actualAtbOffsetTop = $actualAtb.length ? $actualAtb.offset().top : 0;

        toggleStickyAtb($stickyAtb, windowScrollTop, actualAtbOffsetTop);
    }, 100));

    const $footer = document.querySelector('footer');
    const stickyButton = document.querySelector('.sticky-atb');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && stickyButton) {
                stickyButton.classList.add('footer-touched') ;
            } else if (stickyButton) {
                stickyButton.classList.remove('footer-touched');
            }
        });
    }, {
        rootMargin: '0px',
        threshold: 0.1 // Trigger as soon as they touch
    });

    observer.observe($footer);
})(jQuery);

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
detail.handlePostCartAdd = function (response) {
    $('.minicart').trigger('count:update', response);
    // show add to cart toast
    if (response && response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }
}
/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
detail.miniCartReportingUrl = function (url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
* Showing the toast message when the customer has pressed the "Add to Cart" button
* @param {string} response - ajax response from clicking the add to cart button
*/
function toastmessage(response) { // eslint-disable-line no-unused-vars
    const messageType = response.error ? 'error' : 'success';
    const $modal = $('#tryit-modal');
    const modalData = $modal.data();
    const message = response.error ? modalData.errormsg : modalData.sucssessmsg;
    Snackbar.show({
        type: messageType,
        position: 'left',
        message: message
    });
}

/**
 * Safely parse a Porthole message payload.
 * @param {string|Object} messageData - Raw event payload.
 * @returns {Object|null} Parsed payload when available.
 */
function parseTryItMessageData(messageData) {
    if (!messageData) {
        return null;
    }

    if (typeof messageData === 'object') {
        return messageData;
    }

    if (typeof messageData !== 'string') {
        return null;
    }

    try {
        return JSON.parse(messageData);
    } catch (error) {
        return null;
    }
}

/**
 * Normalize a numeric iframe dimension.
 * @param {string|number} value - Raw dimension value.
 * @returns {number|null} Normalized dimension.
 */
function normalizeTryItDimension(value) {
    var numericValue = parseFloat(value);

    if (Number.isNaN(numericValue) || numericValue <= 0) {
        return null;
    }

    return Math.ceil(numericValue);
}

/**
 * Get the visible viewport width for try-it sizing.
 * @returns {number} Viewport width.
 */
function getTryItViewportWidth() {
    if (window.visualViewport && window.visualViewport.width) {
        return Math.round(window.visualViewport.width);
    }

    return window.innerWidth || document.documentElement.clientWidth || 0;
}

/**
 * Get the visible viewport height for try-it sizing.
 * @returns {number} Viewport height.
 */
function getTryItViewportHeight() {
    if (window.visualViewport && window.visualViewport.height) {
        return Math.round(window.visualViewport.height);
    }

    return window.innerHeight || document.documentElement.clientHeight || 0;
}

/**
 * Determine whether the browser is currently pinch-zoomed.
 * @returns {boolean} True when visual viewport scale is above the default level.
 */
function isTryItViewportZoomed() {
    return Boolean(
        window.visualViewport
        && typeof window.visualViewport.scale === 'number'
        && window.visualViewport.scale > 1
    );
}

/**
 * Determine whether try-it modal sizing should use the mobile fullscreen path.
 * @returns {boolean} True when viewport is mobile-sized.
 */
function isTryItMobileViewport() {
    var hasCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var hasTouchPoints = typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0;
    var viewportHeight = getTryItViewportHeight();
    var viewportWidth = getTryItViewportWidth();
    var largestViewportDimension = Math.max(viewportWidth, viewportHeight);
    var smallestViewportDimension = Math.min(viewportWidth, viewportHeight);

    return (hasCoarsePointer || hasTouchPoints)
        && smallestViewportDimension < TRY_IT_MOBILE_BREAKPOINT
        && largestViewportDimension < TRY_IT_MOBILE_MAX_DIMENSION;
}

/**
 * Determine whether the viewport is narrow but should still use constrained desktop sizing.
 * @returns {boolean} True when viewport is narrow and not mobile-fullscreen.
 */
function isTryItConstrainedViewport() {
    return !isTryItMobileViewport() && getTryItViewportWidth() < TRY_IT_MOBILE_BREAKPOINT;
}

/**
 * Get the available viewport height after the try-it desktop dialog margins.
 * @returns {number} Available height.
 */
function getTryItAvailableViewportHeight() {
    var viewportHeight = getTryItViewportHeight();

    if (isTryItMobileViewport()) {
        return viewportHeight;
    }

    return Math.max(viewportHeight - TRY_IT_DIALOG_VERTICAL_MARGIN, 320);
}

/**
 * Get the current viewport orientation for try-it sizing state.
 * @returns {string} portrait or landscape.
 */
function getTryItViewportOrientation() {
    return getTryItViewportWidth() >= getTryItViewportHeight() ? 'landscape' : 'portrait';
}

/**
 * Determine whether the try-it modal is currently visible.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @returns {boolean} True when the modal is visible.
 */
function isTryItModalVisible($tryItModal) {
    return Boolean(
        $tryItModal
        && $tryItModal.length
        && $tryItModal.hasClass('show')
        && $tryItModal.is(':visible')
    );
}

/**
 * Get the minimum safe width for a try-it iframe.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {JQuery} $tryItIframe - Iframe receiving the sizing override.
 * @returns {number} Minimum safe width.
 */
function getTryItMinimumWidth($tryItModal, $tryItIframe) {
    var modalBodyWidth = 0;
    var modalContentWidth = 0;
    var iframeWidth = 0;
    var iframeElement;
    var viewportWidth = getTryItViewportWidth();
    var minimumFallbackWidth = Math.min(320, viewportWidth);
    var modalVisible = isTryItModalVisible($tryItModal);

    if ($tryItModal && $tryItModal.length) {
        modalBodyWidth = $tryItModal.find('.modal-body').first().innerWidth() || 0;
        modalContentWidth = $tryItModal.find('.modal-content').first().innerWidth() || 0;
    }

    if (modalVisible && $tryItIframe && $tryItIframe.length) {
        iframeElement = $tryItIframe.get(0);
        iframeWidth = iframeElement ? Math.round(iframeElement.getBoundingClientRect().width) : 0;
    }

    return Math.max(modalBodyWidth, modalContentWidth, iframeWidth, minimumFallbackWidth);
}

/**
 * Get the minimum iframe height required for the vendor aspect ratio.
 * @param {number} width - Applied iframe width.
 * @returns {number|null} Aspect-ratio-derived height.
 */
function getTryItAspectRatioHeight(width) {
    if (!width || width <= 0) {
        return null;
    }

    return Math.round(
        (width * TRY_IT_IFRAME_ASPECT_RATIO_HEIGHT) / TRY_IT_IFRAME_ASPECT_RATIO_WIDTH
    );
}

/**
 * Get the minimum iframe width required for the vendor aspect ratio.
 * @param {number} height - Applied iframe height.
 * @returns {number|null} Aspect-ratio-derived width.
 */
function getTryItAspectRatioWidth(height) {
    if (!height || height <= 0) {
        return null;
    }

    return Math.round(
        (height * TRY_IT_IFRAME_ASPECT_RATIO_WIDTH) / TRY_IT_IFRAME_ASPECT_RATIO_HEIGHT
    );
}

/**
 * Determine whether the current iframe belongs to Mirror Me.
 * @param {JQuery} $tryItIframe - Iframe receiving the sizing override.
 * @returns {boolean} True when sizing Mirror Me.
 */
function isMirrorMeTryItIframe($tryItIframe) {
    if (!$tryItIframe || !$tryItIframe.length) {
        return false;
    }

    return $tryItIframe.is('#MirrorMe') || $tryItIframe.hasClass('mirror-me-Iframe');
}

/**
 * Apply a small non-mobile width trim for Mirror Me to avoid internal vertical scroll.
 * @param {JQuery} $tryItIframe - Iframe receiving the sizing override.
 * @param {number|null} width - Width to adjust.
 * @returns {number|null} Width with app-specific adjustment applied.
 */
function getTryItSafeNonMobileWidth($tryItIframe, width) {
    if (!width || width <= 0) {
        return null;
    }

    if (!isMirrorMeTryItIframe($tryItIframe)) {
        return width;
    }

    return Math.max(
        Math.round(width * TRY_IT_MIRROR_ME_NON_MOBILE_WIDTH_SAFETY_FACTOR),
        1
    );
}

/**
 * Get the non-mobile height buffer for the current try-it app.
 * @param {JQuery} $tryItIframe - Iframe receiving the sizing override.
 * @returns {number} Height buffer to apply.
 */
function getTryItNonMobileHeightBuffer($tryItIframe) {
    return isMirrorMeTryItIframe($tryItIframe) ? TRY_IT_IFRAME_HEIGHT_BUFFER : 0;
}

/**
 * Fit iframe dimensions inside the available viewport while preserving aspect ratio.
 * @param {number|null} width - Natural iframe width.
 * @param {number|null} height - Natural iframe height.
 * @param {number} maxWidth - Available viewport width.
 * @param {number} maxHeight - Available viewport height.
 * @returns {Object|null} Contained dimensions.
 */
function getTryItContainedDimensions(width, height, maxWidth, maxHeight) {
    var aspectRatio;
    var containedHeight;
    var containedWidth;

    if (!width || !height || !maxWidth || !maxHeight) {
        return null;
    }

    aspectRatio = width / height;
    containedWidth = Math.min(width, maxWidth);
    containedHeight = Math.round(containedWidth / aspectRatio);

    if (containedHeight > maxHeight) {
        containedHeight = maxHeight;
        containedWidth = Math.round(containedHeight * aspectRatio);
    }

    return {
        height: containedHeight,
        width: containedWidth
    };
}

/**
 * Read the last stored vendor resize payload for a modal.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @returns {Object|null} Stored vendor dimensions.
 */
function getStoredTryItModalDimensions($tryItModal) {
    var storedDimensions;

    if (!$tryItModal || !$tryItModal.length) {
        return null;
    }

    storedDimensions = $tryItModal.data('tryitLastDimensions');

    return storedDimensions || null;
}

/**
 * Toggle vertical centering based on rendered try-it modal height.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {number|null} iframeHeight - Applied iframe height.
 * @returns {void}
 */
function updateTryItModalVerticalAlignment($tryItModal, iframeHeight) {
    var viewportHeight;
    var shouldCenter;

    if (!$tryItModal || !$tryItModal.length) {
        return;
    }

    if (isTryItMobileViewport()) {
        $tryItModal.removeClass('tryit-modal--centered');
        return;
    }

    viewportHeight = getTryItViewportHeight();
    shouldCenter = Boolean(iframeHeight && iframeHeight < viewportHeight);

    $tryItModal.toggleClass('tryit-modal--centered', shouldCenter);
}

/**
 * Toggle modal viewport mode classes for mobile-specific layout overrides.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @returns {void}
 */
function updateTryItModalViewportMode($tryItModal) {
    var isMobileViewport;

    if (!$tryItModal || !$tryItModal.length) {
        return;
    }

    isMobileViewport = isTryItMobileViewport();

    $tryItModal.toggleClass('tryit-modal--mobile-viewport', isMobileViewport);
    $tryItModal.toggleClass('tryit-modal--constrained-viewport', !isMobileViewport && isTryItConstrainedViewport());
}

/**
 * Determine whether the incoming vendor resize payload matches the current modal state.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {Object} resizeData - Vendor resize payload.
 * @returns {boolean} True when the resize is already applied.
 */
function isDuplicateTryItVendorResize($tryItModal, resizeData) {
    var storedDimensions;

    if (!$tryItModal || !$tryItModal.length || !resizeData) {
        return false;
    }

    storedDimensions = getStoredTryItModalDimensions($tryItModal);

    return Boolean(
        storedDimensions
        && storedDimensions.source === 'vendor'
        && storedDimensions.orientation === getTryItViewportOrientation()
        && storedDimensions.width === (resizeData.width || null)
        && storedDimensions.height === (resizeData.height || null)
    );
}

/**
 * Persist the last valid try-it resize payload on the modal.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {Object} dimensions - Parsed dimensions.
 * @returns {void}
 */
function storeTryItModalDimensions($tryItModal, dimensions) {
    if (!$tryItModal || !$tryItModal.length || !dimensions) {
        return;
    }

    $tryItModal.data('tryitLastDimensions', {
        height: dimensions.height || null,
        orientation: getTryItViewportOrientation(),
        source: 'vendor',
        width: dimensions.width || null
    });
}

/**
 * Build viewport-adaptive fallback dimensions for refresh events.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {JQuery} $tryItIframe - Iframe receiving the sizing override.
 * @returns {Object|null} Fallback dimensions.
 */
function getTryItViewportFallbackDimensions($tryItModal, $tryItIframe) {
    var iframeElement;
    var fallbackWidth;
    var fallbackHeight;
    var minimumWidth;
    var viewportHeight;
    var viewportWidth;
    var modalVisible;

    if (!$tryItModal || !$tryItModal.length || !$tryItIframe || !$tryItIframe.length) {
        return null;
    }

    $tryItIframe.css('--tryit-iframe-height', '');
    $tryItIframe.css('--tryit-iframe-width', '');

    viewportWidth = getTryItViewportWidth();
    viewportHeight = getTryItViewportHeight();
    minimumWidth = getTryItMinimumWidth($tryItModal, $tryItIframe);
    modalVisible = isTryItModalVisible($tryItModal);

    if (isTryItMobileViewport()) {
        return {
            orientation: getTryItViewportOrientation(),
            source: 'fallback',
            width: viewportWidth,
            height: viewportHeight
        };
    }

    iframeElement = $tryItIframe.get(0);
    fallbackWidth = modalVisible && iframeElement
        ? Math.round(iframeElement.getBoundingClientRect().width)
        : 0;

    if (!fallbackWidth) {
        fallbackWidth = modalVisible ? minimumWidth : viewportWidth;
    }

    fallbackWidth = Math.min(Math.max(fallbackWidth, minimumWidth), viewportWidth);
    fallbackHeight = getTryItAspectRatioHeight(fallbackWidth);

    if (!fallbackWidth && !fallbackHeight) {
        return null;
    }

    return {
        orientation: getTryItViewportOrientation(),
        source: 'fallback',
        width: fallbackWidth,
        height: fallbackHeight
    };
}

/**
 * Rebuild dimensions for the current orientation using the last vendor aspect ratio.
 * @param {Object} dimensions - Last known vendor dimensions.
 * @returns {Object|null} Orientation-adjusted dimensions.
 */
function getTryItOrientationAdjustedDimensions(dimensions) {
    var availableHeight;
    var containedDimensions;
    var defaultHeight;
    var defaultWidth;
    var maxContentHeight;
    var viewportWidth;

    if (!dimensions || !dimensions.width || !dimensions.height) {
        return null;
    }

    if (isTryItMobileViewport()) {
        return {
            orientation: getTryItViewportOrientation(),
            source: 'fallback',
            width: getTryItViewportWidth(),
            height: getTryItViewportHeight()
        };
    }

    viewportWidth = getTryItViewportWidth();
    availableHeight = getTryItAvailableViewportHeight();
    defaultHeight = dimensions.height;
    maxContentHeight = Math.max(availableHeight - TRY_IT_IFRAME_HEIGHT_BUFFER, 0);

    if (!defaultHeight) {
        defaultHeight = getTryItAspectRatioHeight(viewportWidth);
    }

    defaultWidth = getTryItAspectRatioWidth(defaultHeight) || viewportWidth;

    containedDimensions = getTryItContainedDimensions(
        defaultWidth,
        defaultHeight,
        viewportWidth,
        maxContentHeight || availableHeight
    );

    if (!containedDimensions) {
        return null;
    }

    return {
        orientation: getTryItViewportOrientation(),
        source: 'fallback',
        width: containedDimensions.width,
        height: containedDimensions.height
    };
}

/**
 * Extract resize dimensions from a Porthole message.
 * Supports JSON payloads and query-string style payloads.
 * @param {string|Object} messageData - Raw event payload.
 * @returns {Object|null} Parsed dimensions.
 */
function parseTryItResizeMessage(messageData) {
    var parsedMessage = parseTryItMessageData(messageData);
    var resizeHeight;
    var resizeWidth;
    var messageType;
    var payload;
    var params;

    if (parsedMessage) {
        messageType = parsedMessage.type || parsedMessage.event || parsedMessage.action || parsedMessage.name;
        payload = parsedMessage.payload || parsedMessage.data || parsedMessage.detail;
        resizeHeight = normalizeTryItDimension(
            parsedMessage.height
            || parsedMessage.iframeHeight
            || parsedMessage.modalHeight
            || (payload && payload.height)
            || (parsedMessage.size && parsedMessage.size.height)
        );
        resizeWidth = normalizeTryItDimension(
            parsedMessage.width
            || parsedMessage.iframeWidth
            || parsedMessage.modalWidth
            || (payload && payload.width)
            || (parsedMessage.size && parsedMessage.size.width)
        );

        if ((messageType === 'foundationMatchAppResize'
            || messageType === 'mkrealtimeAppResize')
            && (resizeHeight || resizeWidth)) {
            return {
                height: resizeHeight,
                width: resizeWidth
            };
        }

        return null;
    }

    if (typeof messageData !== 'string' || messageData.indexOf('=') === -1) {
        return null;
    }

    params = new URLSearchParams(messageData);
    messageType = params.get('type') || params.get('event') || params.get('action') || params.get('name');
    resizeHeight = normalizeTryItDimension(
        params.get('height') || params.get('iframeHeight') || params.get('modalHeight')
    );
    resizeWidth = normalizeTryItDimension(
        params.get('width') || params.get('iframeWidth') || params.get('modalWidth')
    );

    if ((messageType === 'foundationMatchAppResize' || messageType === 'mkrealtimeAppResize')
        && (resizeHeight || resizeWidth)) {
        return {
            height: resizeHeight,
            width: resizeWidth
        };
    }

    return null;
}

/**
 * Apply modal sizing overrides received from the iframe.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @param {Object} dimensions - Parsed dimensions.
 * @returns {void}
 */
function applyTryItModalDimensions($tryItModal, dimensions) {
    var $tryItIframe;
    var containedDimensions;
    var defaultHeight;
    var defaultWidth;
    var isMirrorMeIframe;
    var iframeHeightBuffer;
    var isMobileViewport;
    var maxContentHeight;
    var safeHeight;
    var safeWidth;
    var availableHeight;
    var viewportHeight;
    var viewportWidth;
    var minimumWidth;

    if (!$tryItModal || !$tryItModal.length || !dimensions) {
        return;
    }

    updateTryItModalViewportMode($tryItModal);

    $tryItIframe = $tryItModal.find('.mirror-me-Iframe, .find-my-match-Iframe').first();

    if (!$tryItIframe.length) {
        $tryItIframe = $tryItModal.find('iframe').first();
    }

    if (!$tryItIframe.length) {
        return;
    }

    if (isTryItMobileViewport() && isTryItViewportZoomed()) {
        return;
    }

    viewportWidth = getTryItViewportWidth();
    viewportHeight = getTryItViewportHeight();
    availableHeight = getTryItAvailableViewportHeight();
    isMobileViewport = isTryItMobileViewport();
    isMirrorMeIframe = isMirrorMeTryItIframe($tryItIframe);
    minimumWidth = getTryItMinimumWidth($tryItModal, $tryItIframe);
    iframeHeightBuffer = isMobileViewport
        ? TRY_IT_IFRAME_HEIGHT_BUFFER
        : getTryItNonMobileHeightBuffer($tryItIframe);
    maxContentHeight = Math.max(availableHeight - iframeHeightBuffer, 0);

    if (isMobileViewport) {
        safeWidth = viewportWidth;
        safeHeight = Math.max(viewportHeight, 320);
    } else {
        defaultHeight = dimensions.height || getTryItAspectRatioHeight(viewportWidth);
        defaultWidth = isMirrorMeIframe
            ? getTryItAspectRatioWidth(defaultHeight)
            : dimensions.width;

        if (!defaultWidth) {
            defaultWidth = getTryItAspectRatioWidth(defaultHeight) || viewportWidth;
        }

        if (!defaultWidth) {
            defaultWidth = Math.max(dimensions.width || 0, minimumWidth);
            defaultHeight = dimensions.height || getTryItAspectRatioHeight(defaultWidth);
        }

        if (defaultHeight <= maxContentHeight && defaultWidth <= viewportWidth) {
            containedDimensions = {
                height: defaultHeight,
                width: defaultWidth
            };
        } else {
            containedDimensions = getTryItContainedDimensions(
                defaultWidth,
                defaultHeight,
                viewportWidth,
                maxContentHeight || availableHeight
            );
        }

        if (containedDimensions) {
            safeWidth = getTryItSafeNonMobileWidth($tryItIframe, containedDimensions.width) || containedDimensions.width;
            safeHeight = Math.min(
                containedDimensions.height + iframeHeightBuffer,
                availableHeight
            );
        }
    }

    if (safeHeight) {
        $tryItIframe.css('--tryit-iframe-height', `${safeHeight}px`);
    }

    if (safeWidth) {
        $tryItIframe.css('--tryit-iframe-width', `${safeWidth}px`);
    }

    updateTryItModalVerticalAlignment($tryItModal, safeHeight);
}

/**
 * Clear modal sizing overrides so each open starts from defaults.
 * @param {JQuery} $tryItModal - Modal receiving the iframe.
 * @returns {void}
 */
function resetTryItModalDimensions($tryItModal) {
    var $tryItIframe;

    if (!$tryItModal || !$tryItModal.length) {
        return;
    }

    $tryItIframe = $tryItModal.find('.mirror-me-Iframe, .find-my-match-Iframe').first();

    if (!$tryItIframe.length) {
        $tryItIframe = $tryItModal.find('iframe').first();
    }

    if ($tryItIframe.length) {
        $tryItIframe.css('--tryit-iframe-height', '');
        $tryItIframe.css('--tryit-iframe-width', '');
    }

    $tryItModal.removeData('tryitLastDimensions');
    updateTryItModalViewportMode($tryItModal);
    $tryItModal.removeClass('tryit-modal--centered');
}

/**
 * Get the origin for a remote iframe URL.
 * @param {string} url - Remote iframe URL.
 * @returns {string|null} Origin when valid.
 */
function getTryItOrigin(url) {
    if (!url) {
        return null;
    }

    try {
        return new URL(url, window.location.origin).origin;
    } catch (error) {
        return null;
    }
}

/**
 * Run a callback after layout has settled for a modal sizing pass.
 * @param {Function} callback - Work to run after paint.
 * @returns {void}
 */
function runAfterTryItLayout(callback) {
    var requestFrame = window.requestAnimationFrame || function (fn) {
        return window.setTimeout(fn, 0);
    };

    requestFrame(function () {
        requestFrame(callback);
    });
}

// jQuery IIFE to listen to click event
(function ($) {
    const baseURL = $('.find-my-match-Iframes').attr('data-baseurl');
    const parentSelector = ".product-detail";
    const $parent = $(parentSelector);
    const $modal = $('#tryit-modal', $parent);

    let findMyMatchProxy = null;
    let findMyMatchHandler = null;

    // Mirror me
    const mirrorMeURL = $('.mirror-me-Iframes').attr('data-baseurl');
    const findMyMatchOrigin = getTryItOrigin(baseURL);
    const mirrorMeOrigin = getTryItOrigin(mirrorMeURL);
    const allowedTryItOrigins = [findMyMatchOrigin, mirrorMeOrigin].filter(Boolean);

    let mirrorMeProxy = null;
    let mirrorMeHandler = null;
    let $currentTryItModal = $();
    let tryItResizeTimeout = null;

    /**
     * Resolve a try-it modal that contains the expected iframe.
     * @param {string} iframeSelector - Iframe selector to match.
     * @returns {JQuery} Matching modal.
     */
    function getActiveTryItModal(iframeSelector) {
        var $candidateModal;

        if ($currentTryItModal.length && (!iframeSelector || $currentTryItModal.find(iframeSelector).length)) {
            return $currentTryItModal;
        }

        $candidateModal = $('.tryit-modal.show', $parent).filter(function () {
            return !iframeSelector || $(this).find(iframeSelector).length;
        }).first();

        if ($candidateModal.length) {
            return $candidateModal;
        }

        return $('#tryit-modal', $parent).filter(function () {
            return !iframeSelector || $(this).find(iframeSelector).length;
        }).first();
    }

    /**
     * Resolve the iframe selector for the currently open try-it modal.
     * @returns {string} Iframe selector.
     */
    function getCurrentTryItIframeSelector() {
        var $activeModal = getActiveTryItModal();
        var modalType;

        if (!$activeModal || !$activeModal.length) {
            return '';
        }

        if ($activeModal.find('#MirrorMe').length) {
            return '#MirrorMe';
        }

        if ($activeModal.find('#FindMyMatch').length) {
            return '#FindMyMatch';
        }

        modalType = $activeModal.find('.close').attr('data-type');

        if (modalType === 'mirror-me') {
            return '#MirrorMe';
        }

        if (modalType === 'find-my-match') {
            return '#FindMyMatch';
        }

        return '';
    }

    /**
     * Refresh sizing for a specific try-it modal.
     * @param {JQuery} $tryItModal - Modal to resize.
     * @param {string} iframeSelector - Iframe selector to match.
     * @returns {void}
     */
    function refreshTryItModalDimensions($tryItModal, iframeSelector) {
        var $activeIframe;
        var fallbackDimensions;
        var currentOrientation;
        var orientationAdjustedDimensions;
        var storedDimensions;

        if (!$tryItModal.length || !iframeSelector) {
            return;
        }

        $activeIframe = iframeSelector
            ? $tryItModal.find(iframeSelector).first()
            : $tryItModal.find('iframe').first();

        updateTryItModalViewportMode($tryItModal);

        storedDimensions = getStoredTryItModalDimensions($tryItModal);
        currentOrientation = getTryItViewportOrientation();

        if (storedDimensions && storedDimensions.source === 'vendor'
            && storedDimensions.orientation === currentOrientation) {
            applyTryItModalDimensions($tryItModal, storedDimensions);

            return;
        }

        if (storedDimensions && storedDimensions.source === 'vendor') {
            orientationAdjustedDimensions = getTryItOrientationAdjustedDimensions(storedDimensions);

            if (orientationAdjustedDimensions) {
                applyTryItModalDimensions($tryItModal, orientationAdjustedDimensions);
                return;
            }
        }

        fallbackDimensions = getTryItViewportFallbackDimensions($tryItModal, $activeIframe);

        if (fallbackDimensions) {
            applyTryItModalDimensions($tryItModal, fallbackDimensions);
        }
    }

    /**
     * Refresh the open try-it modal after viewport changes.
     * @returns {void}
     */
    function refreshCurrentTryItModalDimensions() {
        var iframeSelector = getCurrentTryItIframeSelector();
        var $activeModal = getActiveTryItModal(iframeSelector);

        if (!$activeModal.length || !iframeSelector) {
            return;
        }

        refreshTryItModalDimensions($activeModal, iframeSelector);
    }

    /**
     * Clear any pending viewport refresh request.
     * @returns {void}
     */
    function clearPendingTryItResizeTimeout() {
        if (!tryItResizeTimeout) {
            return;
        }

        window.clearTimeout(tryItResizeTimeout);
        tryItResizeTimeout = null;
    }

    /**
     * Schedule a try-it resize request after viewport changes settle.
     * @returns {void}
     */
    function scheduleTryItViewportRefresh() {
        if (isTryItViewportZoomed()) {
            return;
        }

        clearPendingTryItResizeTimeout();

        tryItResizeTimeout = window.setTimeout(function () {
            tryItResizeTimeout = null;
            runAfterTryItLayout(refreshCurrentTryItModalDimensions);
        }, 150);
    }

    /**
     * Register viewport and orientation listeners for try-it modal resizing.
     * @returns {void}
     */
    function registerTryItViewportRefreshListeners() {
        var orientationMediaQuery;

        window.addEventListener('resize', scheduleTryItViewportRefresh);
        window.addEventListener('orientationchange', scheduleTryItViewportRefresh);

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', scheduleTryItViewportRefresh);
        }

        if (window.screen && window.screen.orientation
            && typeof window.screen.orientation.addEventListener === 'function') {
            window.screen.orientation.addEventListener('change', scheduleTryItViewportRefresh);
        }

        if (!window.matchMedia) {
            return;
        }

        orientationMediaQuery = window.matchMedia('(orientation: portrait)');

        if (typeof orientationMediaQuery.addEventListener === 'function') {
            orientationMediaQuery.addEventListener('change', scheduleTryItViewportRefresh);
        } else if (typeof orientationMediaQuery.addListener === 'function') {
            orientationMediaQuery.addListener(scheduleTryItViewportRefresh);
        }
    }

    /**
     * Apply resize data from a trusted postMessage event.
     * @param {MessageEvent} event - Browser message event.
     * @returns {void}
     */
    function handleTryItWindowMessage(event) {
        var iframeSelector;
        var resizeData;
        var $activeModal;

        if (!event || allowedTryItOrigins.indexOf(event.origin) === -1) {
            return;
        }

        if (event.origin === mirrorMeOrigin) {
            iframeSelector = '#MirrorMe';
        } else if (event.origin === findMyMatchOrigin) {
            iframeSelector = '#FindMyMatch';
        }

        resizeData = parseTryItResizeMessage(event.data);

        if (!resizeData) {
            return;
        }

        if (isTryItViewportZoomed()) {
            return;
        }

        $activeModal = getActiveTryItModal(iframeSelector);

        if (isDuplicateTryItVendorResize($activeModal, resizeData)) {
            return;
        }

        storeTryItModalDimensions($activeModal, resizeData);
        applyTryItModalDimensions($activeModal, resizeData);
    }

    window.addEventListener('message', handleTryItWindowMessage);
    registerTryItViewportRefreshListeners();

    /**
     * Initialize Porthole proxy and event listener
     */
    function initializemirrorMeProxy() {
        if (typeof Porthole !== 'undefined') {
            if (mirrorMeProxy && mirrorMeHandler) {
                mirrorMeProxy.removeEventListener(mirrorMeHandler);
            }

            mirrorMeProxy = new Porthole.WindowProxy(mirrorMeURL, 'mirrorMe'); // eslint-disable-line

            mirrorMeHandler = function (event) {
                if (event?.origin !== mirrorMeURL) {
                    return;
                }

                var resizeData = parseTryItResizeMessage(event && event.data);

                if (resizeData) {
                    var $mirrorMeModal = getActiveTryItModal('#MirrorMe');

                    if (isTryItViewportZoomed()) {
                        return;
                    }

                    if (isDuplicateTryItVendorResize($mirrorMeModal, resizeData)) {
                        return;
                    }

                    storeTryItModalDimensions($mirrorMeModal, resizeData);
                    applyTryItModalDimensions($mirrorMeModal, resizeData);
                    return;
                }

                if (typeof event?.data === 'string' && event.data.includes('addToBag')) {
                    const data = event.data;
                    const params = new URLSearchParams(data);
                    const partId = params.get("productId");
                    const quantity = params.get("quantity");
                    var url = $('.add-to-cart-url').val();
                    var form = {
                        pid: partId,
                        quantity: quantity
                    };
                    if (partId && url) {
                        $.ajax({
                            url: url,
                            type: 'post',
                            data: form,
                            success: function (response) {
                                detail.handlePostCartAdd(response);
                                $('body').trigger('product:afterAddToCart', response);
                                detail.miniCartReportingUrl(response.reportingURL);
                                minicart.miniCartShow();
                            }
                        });
                    }
                }
            };

            mirrorMeProxy.addEventListener(mirrorMeHandler);
        }
    }

    /**
     * Initialize Porthole proxy and event listener
     */
    function initializeFindMyMatchProxy() {
        if (typeof Porthole !== 'undefined') {
            if (findMyMatchProxy && findMyMatchHandler) {
                findMyMatchProxy.removeEventListener(findMyMatchHandler);
            }

            findMyMatchProxy = new Porthole.WindowProxy(baseURL, 'FindMyMatch'); // eslint-disable-line

            findMyMatchHandler = function (event) {
                if (event?.origin !== baseURL) {
                    return;
                }

                var resizeData = parseTryItResizeMessage(event && event.data);

                if (resizeData) {
                    var $findMyMatchModal = getActiveTryItModal('#FindMyMatch');

                    if (isTryItViewportZoomed()) {
                        return;
                    }

                    if (isDuplicateTryItVendorResize($findMyMatchModal, resizeData)) {
                        return;
                    }

                    storeTryItModalDimensions($findMyMatchModal, resizeData);
                    applyTryItModalDimensions($findMyMatchModal, resizeData);
                    return;
                }

                // if (event?.origin === baseURL && event?.data && event.data.includes('add_to_cart')) {
                if (typeof event?.data === 'string' && event.data.includes('add_to_cart')) {
                    const eventData = JSON.parse(event.data);
                    const item = eventData.parameters.ecommerce.items[0];
                    const variantId = item.item_variant;
                    const quantity = item.quantity;
                    var url = $('.add-to-cart-url').val();
                    var form = {
                        pid: variantId,
                        quantity: quantity
                    };
                    if (variantId && url) {
                        $.ajax({
                            url: url,
                            type: 'post',
                            data: form,
                            success: function (data) {
                                detail.handlePostCartAdd(data);
                                $('body').trigger('product:afterAddToCart', data);
                                detail.miniCartReportingUrl(data.reportingURL);
                                minicart.miniCartShow();
                            }
                        });
                    }
                }
            };

            findMyMatchProxy.addEventListener(findMyMatchHandler);
        }
    }

    /**
     * Close modal and reset iframe
     * @param {Object} $hostElement - jQuery object representing the host parent element
     */
    function closeModal($hostElement) {
        const $parentElement = $hostElement || $parent;
        const $iframe = $('#FindMyMatch', $parentElement);
        const $openModal = $('#tryit-modal', $parentElement);

        if ($currentTryItModal.length && $currentTryItModal.is($openModal)) {
            $currentTryItModal = $();
        }

        clearPendingTryItResizeTimeout();

        resetTryItModalDimensions($openModal);

        if ($iframe) {
            const src = $iframe.attr('src');
            $iframe.attr('src', '');
            $iframe.attr('src', src);
        }

        if (findMyMatchProxy && findMyMatchHandler) {
            findMyMatchProxy.removeEventListener(findMyMatchHandler);
            findMyMatchHandler = null;
        }
        var findMyMatchmodalBody = $('.find-my-match-Iframes', $parentElement).html();
        if (findMyMatchmodalBody.length) {
            $openModal.find('.modal-body').empty();
        }
        $openModal.modal('hide');
    }

    /**
     * Close modal and reset iframe
     * @param {Object} $hostElement - jQuery object representing the host parent element
     */
    function closeMirrorMeModal($hostElement) {
        const $parentElement = $hostElement || $parent;
        const $iframe = $('#MirrorMe', $parentElement);
        const $openModal = $('#tryit-modal', $parentElement);

        if ($currentTryItModal.length && $currentTryItModal.is($openModal)) {
            $currentTryItModal = $();
        }

        clearPendingTryItResizeTimeout();

        resetTryItModalDimensions($openModal);

        if ($iframe) {
            const src = $iframe.attr('src');
            $iframe.attr('src', '');
            $iframe.attr('src', src);
        }

        if (mirrorMeProxy && mirrorMeHandler) {
            mirrorMeProxy.removeEventListener(mirrorMeHandler);
            mirrorMeHandler = null;
        }

        const mirrorMemodalBody = $('.mirror-me-Iframes', $parentElement).html();
        if (mirrorMemodalBody.length) {
            $openModal.find('.modal-body').empty();
        }
        $openModal.modal('hide');
    }

    $modal.on('hidden.bs.modal', '#tryit-modal', function () {
        const type = $(this).find('.close').attr('data-type');
        var $hostElement = $(this).closest('.product-detail');

        if (type === 'find-my-match') {
            closeModal($hostElement);
        } else if (type === 'mirror-me') {
            closeMirrorMeModal($hostElement);
        }

        $('html').removeAttr('tryit-modal-open');
    });

    /**
     * Open generic modal and initialize iframe and proxy
     * @param {Object} $hostElement - jQuery object representing the host parent element
     * @param {Object} config - Configuration object for modal
     */
    function openGenericModal($hostElement, config) {
        const $parentElement = $hostElement || $parent;
        const $iframe = $(config.iframeSelector, $parentElement);
        const $tryItModal = $('#tryit-modal', $parentElement);
        var $modalIframe;

        $currentTryItModal = $tryItModal;
        updateTryItModalViewportMode($tryItModal);

        resetTryItModalDimensions($tryItModal);

        // Remove any existing handler
        $tryItModal.off('hidden.bs.modal');

        // Attach handler specific to this modal instance
        $tryItModal.on('hidden.bs.modal', function () {
            const type = $(this).find('.close').attr('data-type');
            if (type === 'find-my-match') {
                closeModal($hostElement);
            } else if (type === 'mirror-me') {
                closeMirrorMeModal($hostElement);
            }

            $('html').removeAttr('tryit-modal-open');
        });

        if ($iframe) {
            const src = $iframe.attr('src');
            $iframe.attr('src', src);
        }

        var modalBody = $(config.modalBodySelector, $parentElement).html();

        if (modalBody.length) {
            $tryItModal.find('.modal-body').empty();
            $tryItModal.find('.modal-body').html(modalBody);
            $tryItModal.find('.close').attr('data-type', config.type);

            $modalIframe = $tryItModal.find(config.iframeSelector);

            $tryItModal.off('shown.bs.modal.tryitSizing').on('shown.bs.modal.tryitSizing', function () {
                runAfterTryItLayout(function () {
                    refreshTryItModalDimensions($tryItModal, config.iframeSelector);
                });
            });

            if ($modalIframe.length) {
                $modalIframe.off('load.tryitSizing').one('load.tryitSizing', function () {
                    runAfterTryItLayout(function () {
                        refreshTryItModalDimensions($tryItModal, config.iframeSelector);
                    });
                });
            }

            $('html').attr('tryit-modal-open', 'true');
            $tryItModal.modal('show');
        }

        config.initializeProxy();
    }

    /**
     * Open modal and initialize iframe and proxy
     * @param {Object} $hostElement - jQuery object representing the host parent element
     */
    function openModal($hostElement) {
        openGenericModal($hostElement, {
            iframeSelector: '#FindMyMatch',
            modalBodySelector: '.find-my-match-Iframes',
            type: 'find-my-match',
            initializeProxy: initializeFindMyMatchProxy
        });
    }

    /**
     * Open modal and initialize iframe and proxy
     * @param {Object} $hostElement - jQuery object representing the host parent element
     */
    function openMirrorMeModal($hostElement) {
        openGenericModal($hostElement, {
            iframeSelector: '#MirrorMe',
            modalBodySelector: '.mirror-me-Iframes',
            type: 'mirror-me',
            initializeProxy: initializemirrorMeProxy
        });
    }



    $parent.off('click', '.find-my-match-js').on('click', '.find-my-match-js', function (e) {
        e.preventDefault();
        const $hostElement = $(this).closest('.product-detail');

        if ($hostElement.length === 0) {
            console.error('find-my-match-js button not inside .product-detail container');
            return;
        }

        openModal($hostElement);
    });

    $parent.off('click', '.mirror-me-js').on('click', '.mirror-me-js', function (e) {
        e.preventDefault();
        const $hostElement = $(this).closest('.product-detail');

        if ($hostElement.length === 0) {
            console.error('mirror-me-js button not inside .product-detail container');
            return;
        }

        openMirrorMeModal($hostElement);
    });

    if (typeof Porthole !== 'undefined') {
        Porthole.WindowProxyDispatcher.start(); // eslint-disable-line
    }

    $parent.off('keydown', '.product-details-accordion .card-header').on('keydown', '.product-details-accordion .card-header', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            $(this).find('.btn').trigger('click');
        }
    });
})(jQuery);
module.exports = { ...base, ...detail };
